"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#121110",
          fontFamily: "system-ui, sans-serif",
          color: "#E8E4DF",
        }}
      >
        <h1 style={{ fontSize: "2rem", fontWeight: 700, letterSpacing: "0.05em" }}>
          Something went wrong
        </h1>
        <p style={{ marginTop: "0.5rem", color: "#9A958B", fontSize: "15px" }}>
          A critical error occurred. Please try refreshing the page.
        </p>
        <button
          onClick={reset}
          style={{
            marginTop: "2rem",
            padding: "0.625rem 1.25rem",
            backgroundColor: "#F59E0B",
            color: "#121110",
            border: "none",
            borderRadius: "6px",
            fontSize: "15px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Try Again
        </button>
      </body>
    </html>
  );
}
